/**
 * Format the date.
 * @param dateString - The date string.
 * @returns The formatted date.
 */
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  })
}

const RELATIVE_UNITS: [Intl.RelativeTimeFormatUnit, number][] = [
  ["year", 60 * 60 * 24 * 365],
  ["month", 60 * 60 * 24 * 30],
  ["week", 60 * 60 * 24 * 7],
  ["day", 60 * 60 * 24],
  ["hour", 60 * 60],
  ["minute", 60],
]

/**
 * Format a timestamp relative to now ("3 days ago", "just now").
 * @param dateString - The date string.
 * @returns The formatted relative time.
 */
export function formatRelativeTime(dateString: string): string {
  const seconds = (Date.now() - new Date(dateString).getTime()) / 1000
  if (seconds < 60) return "just now"

  const formatter = new Intl.RelativeTimeFormat("en", { numeric: "always" })
  for (const [unit, unitSeconds] of RELATIVE_UNITS) {
    if (seconds >= unitSeconds) {
      return formatter.format(-Math.floor(seconds / unitSeconds), unit)
    }
  }
  return "just now"
}

/**
 * Format the duration of the track.
 * @param seconds - The duration of the track in seconds.
 * @returns The formatted duration.
 */
export function formatDuration(seconds?: number | null): string | null {
  if (!seconds) return null
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, "0")}`
}
